/**
 * Opens staff public preview using real API data (?preview=staff).
 * No localStorage writes — preview loads via staff opportunity-by-slug endpoint.
 */
export function openStaffPublicPreview(opportunitySlugOrId) {
  if (!opportunitySlugOrId) return;
  const url = `${window.location.origin}/invest/investments/${opportunitySlugOrId}?preview=staff`;
  window.open(url, "_blank", "noopener,noreferrer");
}
